/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
// Add custom code below this line
  document.addEventListener('DOMContentLoaded', () => {
  const currentUrl = new URL(window.location.href);
  if (currentUrl.searchParams.has('variant')) {
    currentUrl.searchParams.delete('variant');
    window.history.replaceState({}, document.title, currentUrl.toString());
  }
});
  
  document.addEventListener('DOMContentLoaded', () => {
  const currentUrl = window.location.href;
  if (currentUrl.includes('/collections/') && currentUrl.includes('/products/')) {
    const canonicalUrl = currentUrl.replace(/\/collections\/.*\/products\//, '/products/');
    window.history.replaceState({}, '', canonicalUrl);
  }
});

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
